<template>
  <div class="auth" id="auth" name="auth">
    <div class="top">
      <NavTop activeIndex="3"></NavTop>
    </div>
    <div class="content-box">
      <div class="" style="font-size: 24px;font-weight: bold;margin-bottom: 32px;">修改密码</div>
      <div class=""
        style="width: 848px;height: 94px;background-color: #f6f6f6;display: flex;align-items: center;justify-content: center;font-size: 20px;">
        <div class="" style="display: flex;align-items: center;">
          <div class=""
            style="width: 10px;height: 10px;background-color: #ffb600;border-radius: 50%;margin-left: 10px;"></div>
          <div class="" style="font-size: 20px;margin: 0 10px;">
            验证身份
          </div>
        </div>
        <div class="" style="width: 140px;height: 1px;border-bottom: 1px dashed #000;"></div>
        <div class="" style="display: flex;align-items: center;">
          <div class=""
            style="width: 10px;height: 10px;background-color: #ffb600;border-radius: 50%;margin-left: 10px;"></div>
          <div class="" style="font-size: 20px;margin: 0 10px;color: #999;">
            修改新密码
          </div>
        </div>
        <div class="" style="width: 140px;height: 1px;border-bottom: 1px dashed #000;"></div>
        <div class="" style="display: flex;align-items: center;">
          <div class=""
            style="width: 10px;height: 10px;background-color: #ffb600;border-radius: 50%;margin-left: 10px;"></div>
          <div class="" style="font-size: 20px;margin: 0 10px;color: #999;">
            修改成功
          </div>
        </div>
      </div>
      <el-form :model="LoginUser" status-icon ref="ruleForm" class="demo-ruleForm" style="">
        <el-form-item prop="name">
          <div class="" style="display: flex;display: flex;align-items: center;border-bottom: 1px solid #e6e6e6;">
            <div class=""
              style="line-height: 20px;border: 1px solid #fff;height: 20px;box-sizing: border-box;margin-right: 10px;">
              +86
            </div>
            <div class="" style="flex: 1;">
              <el-input type="idcard" placeholder="请输入手机号" v-model="name" maxlength="11"></el-input>
            </div>
          </div>
        </el-form-item>
        <el-form-item prop="pass">
          <div class="pass-box" style="display: flex;justify-content: space-between;">
            <div class="" style="border-bottom: 1px solid #e6e6e6;flex: 1;margin-right: 10px;">
              <el-input type="password" placeholder="请输入验证码" v-model="code" size="mini" maxlength="6"></el-input>
            </div>
            <div class="" @click="getCode" style="position: relative;width: 84px;">
              <div class=""
                style="color: #000;cursor: pointer;background-color: #eee;position: absolute;width: 84px;right: 0;height: 27px;line-height: 27px;text-align: center;bottom: 0;border-radius: 4px;">
                {{ buttonText }}</div>
            </div>
          </div>
        </el-form-item>
        <el-form-item prop="name">
          <div class="" style="display: flex;display: flex;align-items: center;border-bottom: 1px solid #e6e6e6;">
            <div class="" style="flex: 1;">
              <el-input type="idcard" placeholder="请输入新密码" v-model="pass" maxlength="11"></el-input>
            </div>
          </div>
        </el-form-item>
      </el-form>
      <div class=""
        style="width: 300px;height: 36px;text-align: center;line-height: 36px;border-radius: 4px;margin: 60px auto;background-color: #efefef;">
        下一步</div>
    </div>
  </div>
</template>
<script>
import NavTop from '../components/NavTopWhit.vue'
import {
    sendCode
} from '../api/user'
export default {
  components: {
    NavTop
  },
  data() {
    return {
      name: '',
      pass: '',
      buttonText: '获取验证码',
    }
  },
  methods: {
   getCode() {
      // const userNameRule = /^1[3456789]\d{9}$/;
      // if (!userNameRule.test(this.LoginUser.name)) {
      //   this.$message({
      //     message: '请输入正确手机号',
      //     type: 'warning'
      //   });
      //   return
      // }
      if(this.LoginUser.name){
        this.$message({
          message:'请输入手机号',
          type:"warning"
        })
      }
     
      if (this.buttonText != '获取验证码') {
        this.$message({
          message: '倒计时结束之后再发送',
          type: 'warning'
        });
        return
      }
      sendCode({
        mobile: this.LoginUser.name,
      }).then(res => {
        console.log(res);
        if (res.code == 1) {
          console.log(res);
          this.sended = true;
          this.buttonText = '已发送';
          let countDown = 60;
          const timer = setInterval(() => {
            if (countDown > 0) {
              this.buttonText = `${countDown}s 后重试`;
            } else {
              this.sended = false;
              this.buttonText = '获取验证码';
              clearInterval(timer);
            }
            countDown--;
          }, 1000);
          console.log('验证码已发送');
        } else {
          this.notifyError(res.msg);
        }
      })
    }
  }
}

</script>
<style scoped>
.content-box {
  width: 1000px;
  height: 610px;
  background-color: #fff;
  margin: 140px auto;
  padding: 68px 68px 105px;
  box-sizing: border-box;
}

.el-form {
  width: 300px;
  margin: 80px auto;
}
</style>